import * as PL2 from '@common/utils/dist/models/models-pl2.js';
import {UtilsPL2 as U} from '@common/utils/dist/utils/utils-pl2.js';
import {curriculumRegister} from '@constants/app.config';
import {UserDetailsStore} from '@stores/user-details.store';

/**
 * Merges fetched user details into the store, giving priority to
 * non-empty local values. Skips the merge entirely if the local
 * state has a newer `uAt` than the incoming data, preventing
 * stale server responses from overwriting recent local changes.
 */
export function mergeUserDetails(
  fetched: PL2.UserDetails,
  store: UserDetailsStore,
): void {
  const current = store.state();
  if (current.uAt && fetched.uAt && fetched.uAt < current.uAt) {
    return;
  }
  const merged = {...fetched};
  for (const key of Object.keys(current)) {
    if (!U.isEmpty(current[key])) {
      merged[key] = current[key];
    }
  }
  store.setState(merged);
}

export function buildLicenseLogos(curriculums?: {
  [perId: string]: PL2.License;
}): {src: string; alt: string}[] {
  if (U.isEmpty(curriculums)) {
    return [];
  }

  const seen = new Set<string>();
  const logos: {src: string; alt: string}[] = [];

  for (const license of Object.values(curriculums)) {
    if (!license.curPK) {
      continue;
    }
    const attrs = curriculumRegister[license.curPK];
    if (!attrs?.logo || seen.has(attrs.logo)) {
      continue;
    }
    seen.add(attrs.logo);
    logos.push({
      src: `./assets/images/premium/${attrs.logo}`,
      alt: attrs.author,
    });
  }

  return logos;
}
